import {
  createDesignerRole,
  deleteDesignerRole,
  getDesignerScreenAuthorization,
  listDesignerRoles,
  setDesignerScreenAuthorization,
  setDesignerScreenRole,
  updateDesignerRole
} from "../../designer-authorization-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

function safeParse(val: any): any {
  if (val == null) return val;
  if (typeof val === "string") {
    try {
      return JSON.parse(val);
    } catch {
      return val;
    }
  }
  return val;
}

export const roleTools: ToolHandlerGroup = {
  sync: {
    ui_project_list_roles: () => {
      return listDesignerRoles(getSdInstance());
    },

    ui_project_get_screen_authorization: () => {
      return getDesignerScreenAuthorization(getSdInstance());
    },

    ui_project_set_screen_authorization: (input) => {
      return setDesignerScreenAuthorization(getSdInstance(), {
        allowAnonymousAccess: safeParse(input.allowAnonymousAccess),
        allowAllRoles: safeParse(input.allowAllRoles),
        isHidden: safeParse(input.isHidden),
        isDisabled: safeParse(input.isDisabled),
        roleIds: safeParse(input.roleIds)
      });
    }
  },

  // KOA-18448 — the three role MUTATIONS live here, not in `sync`, because their answer must
  // mean "written". As sync handlers they returned the moment the local list was touched, while
  // the project save was still in flight: three creates in one turn all reported success and one
  // of the roles was then missing from the very next read (live `2f2a631b`). `list_roles` and the
  // authorization reads stay sync — they mutate nothing and have nothing to wait for.
  async: {
    ui_project_create_role: async (input) => {
      return createDesignerRole(getSdInstance(), {
        name: input.name,
        startingScreenId: input.startingScreenId
      });
    },

    ui_project_update_role: async (input) => {
      return updateDesignerRole(getSdInstance(), {
        roleId: input.roleId,
        name: input.name,
        startingScreenId: input.startingScreenId
      });
    },

    ui_project_delete_role: async (input) => {
      return deleteDesignerRole(getSdInstance(), input.roleId);
    },

    ui_project_set_screen_role: async (input) => {
      return setDesignerScreenRole(getSdInstance(), {
        screenRole: input.screenRole,
        screenId: input.screenId
      });
    }
  }
};
